import get from 'lodash/get';

export const selectShowError = (state) => get(state, 'errors.showError', false);
export const selectErrorMessage = (state) => get(state, 'errors.message', 'An error has occured.');
